import AppletError from './AppletError';
import { IBaseSosErrorParams } from './SosError';

export interface IAppletDisplayErrorParams extends IBaseSosErrorParams {
	kind: 'appletDisplayError';
}

export default class AppletDisplayError extends AppletError {
	constructor(parameters: IAppletDisplayErrorParams) {
		super({
			...parameters,
			kind: 'appletError',
		});
		this.name = 'AppletDisplayError';
	}
}
